__turbopack_context__.v({
  "ageProfileWrapper": "MDBuIa_ageProfileWrapper",
  "chevron": "MDBuIa_chevron",
  "collapsibleHeader": "MDBuIa_collapsibleHeader",
  "content": "MDBuIa_content",
  "divider": "MDBuIa_divider",
  "extraCostsWrapper": "MDBuIa_extraCostsWrapper",
  "footerWrapper": "MDBuIa_footerWrapper",
  "grossPrice": "MDBuIa_grossPrice",
  "priceRowDiscount": "MDBuIa_priceRowDiscount",
  "rowHeader": "MDBuIa_rowHeader",
  "section": "MDBuIa_section",
  "sectionTinted": "MDBuIa_sectionTinted",
  "strongText": "MDBuIa_strongText",
  "subtotalsWrapper": "MDBuIa_subtotalsWrapper",
  "textLine": "MDBuIa_textLine",
  "textWrapper": "MDBuIa_textWrapper",
  "trailing": "MDBuIa_trailing",
  "usp": "MDBuIa_usp",
  "uspIcon": "MDBuIa_uspIcon",
  "uspsWrapper": "MDBuIa_uspsWrapper",
});
